import React, {FC} from 'react';
import {PageContainer, Wrapper} from "./styled";

type Props = {
    children: React.ReactNode;
};

const SimpleLayout: FC<Props> = (props) => {
    return (
        <Wrapper>
            <PageContainer>
                {props.children}
            </PageContainer>
        </Wrapper>
    );
};

export default SimpleLayout;
